<template>
  <div>
    <v-card v-if="options && options.length > 0" outlined class="px-4 pb-4 pt-2">
      <Checkbox v-for="(option, i) in options"
        :key="`option-${i}`"
        v-model="localModelValue"
        v-bind="{ ...$attrs, ...commonAttrs }" 
        :label="option[optionText] || ''"
        :value="option[optionValue] || option['id']"
        v-on="$listeners"
      />
    </v-card>
    <NoResultsAlert v-else />
  </div>
</template>

<script>
import NoResultsAlert from '@/components/NoResultsAlert.vue'

export default {
  name: 'CheckboxGroup',
  inheritAttrs: false,
  components: {
    NoResultsAlert,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    indexServiceAction: {
      type: Function,
      required: false,
    },
    indexServiceParams: {
      type: Object,
      default: () => ({}),
    },
    optionText: {
      type: String,
      required: false,
    },
    optionValue: {
      type: String,
      required: false,
    },
    limit: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      options: [],
    };
  },
  watch: {
    indexServiceParams: {
      deep: true,
      handler() {
        this.executeIndexServiceAction();
      },
    },
  },
  created() {
    this.executeIndexServiceAction();
  },
  computed: {
    localModelValue: {
      get: function() {
        return this.modelValue;
      },
      set: function(value) {
        this.$emit('update:modelValue', value);
      }
    },
    commonAttrs() {
      return {
        hideDetails: 'auto',
      }
    },
  },
  methods: {
    async executeIndexServiceAction() {
      if (!this.indexServiceAction) return;
      this.options = [];
      try {
        const { data } = await this.indexServiceAction(
          {
            page: {
              limit: this.limit || 100,
            },
            ...this.indexServiceParams,
          }
        );
        this.options = data;
        this.$emit('options:are-empty', (this.options || [])?.length > 0);
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>
<style lang="css" scoped>
/deep/ .v-input__slot {
  padding-left: 0px !important;
}
</style>